export default class extends HTMLElement {
  connectedCallback () {
    this.querySelectorAll('a').forEach((link) => {
      if (document.location.pathname.startsWith(link.pathname) && !link.getAttribute('href').startsWith('http')) {
        // Item ativo no padrão Campo Lavanda: pill branca com sombra (mesma
        // gramática das sidebars de Documentos/Modelos).
        link.classList.add('bg-base-100', 'shadow-raised', '!text-[color:var(--color-accent-fg)]', 'font-semibold')
      }
    })
  }
}
